import { Boxes, Building2, Factory, GitBranch, Zap, type LucideIcon } from 'lucide-react'
import { tok } from '@/charts'
import type { LifecycleState } from '@/lib/api/twin'

/** Asset type is read from form (icon + label), never colour — colour stays for risk. */
export const ASSET_TYPES: Record<string, { label: string; Icon: LucideIcon }> = {
  battery_container: { label: 'Battery container', Icon: Boxes },
  inverter: { label: 'Inverter skid', Icon: Zap },
  transformer: { label: 'Transformer', Icon: Factory },
  switchgear: { label: 'Switchgear', Icon: GitBranch },
  control_room: { label: 'Control room', Icon: Building2 },
}
export const TYPE_OPTIONS = Object.entries(ASSET_TYPES).map(([id, m]) => ({ id, label: m.label }))
export const typeLabel = (t?: string | null) => (t ? ASSET_TYPES[t]?.label ?? t : 'Asset')
export const TypeIcon = (t?: string | null): LucideIcon => (t && ASSET_TYPES[t]?.Icon) || Boxes

/** Lifecycle order + tone (warm→cool: operational cool/managed, impaired warm/live). */
export const LIFECYCLE: { id: LifecycleState; label: string; tone: string }[] = [
  { id: 'planned', label: 'Planned', tone: tok('--clear') },
  { id: 'commissioning', label: 'Commissioning', tone: tok('--trace') },
  { id: 'operational', label: 'Operational', tone: tok('--stable') },
  { id: 'impaired', label: 'Impaired', tone: tok('--flare') },
  { id: 'decommissioned', label: 'Decommissioned', tone: tok('--faint') },
]
export const lcMeta = (s: string) =>
  LIFECYCLE.find((l) => l.id === s) ?? { id: s as LifecycleState, label: s, tone: tok('--muted-foreground') }
